import axiosInstance from "../axiosInterceptor";

export async function getHotCourses(search = "") {
    const response = await axiosInstance.get(`/admin/course/getHotCourses${search ? `?search=${encodeURIComponent(search)}` : ''}`);
    const data = response?.data;
    return data;
}